import React, { useState, useRef, useEffect,useMemo } from 'react';
import {
  MessageCircleMore,
  File, TriangleAlert,
  FileText,X,List,Grid,BringToFront,ExternalLink,
  FileSpreadsheet,Link,
  FileImage,ChevronDown,
  FileVideo,TableOfContents,
  FileAudio,Archive,
  Files,Home,Send,MessageCircle, Plus, MoreHorizontal, Calendar, User, Flag, CheckCircle, Circle, Clock, AlertCircle, Trash2, Edit2, GripVertical, Filter, Search, Bell, Settings, Download, Upload, Users, Target, BarChart3, TrendingUp, Forward, 
  Eye,ChevronRight} from 'lucide-react';
import './digitalsuccessroom.css'
import './digitalsuccessroom2.css'
import './digitalsuccessroom3.css'
import './digitalsuccessroom4.css'
import './digitalsuccessroom5.css'
import { useParams } from 'react-router-dom'
import {ViewTaskModal} from './diff_modals'
import toast, { Toaster } from 'react-hot-toast';
import senteventdata from './sentdata_sg_analytics'
import axios from "axios";
import { BeatLoader } from 'react-spinners';
import { motion, AnimatePresence } from 'framer-motion';
import AnalyticsComponent from './analytics';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';

import LoadingScreen from './loadingscreen';
import RichTextEditor from './richtexteditor';
import SkeletonWrapper from './skeletonwrapper';
import custom_api_func2 from './axios_api_func_2';
import {getCookie,getCsrfToken} from './get_csrfToken'

const DigitalSuccessRoomUniv = () => {
  const [activeTab, setActiveTab] = useState('success-plan');
  const [chatOpen, setChatOpen] = useState(false);
  const [loading,setloading] = useState(true)


  var { dsrtokenid } = useParams()

  const [csrftoken,setcsrftoken] = useState(null)
  async function  fetch_csrf_token(){
    await getCsrfToken();
    setcsrftoken(getCookie('csrftoken'))
  }
  useEffect(() => {
  
      fetch_csrf_token()
      // eslint-disable-next-line
    }, []);
  
 
  const [username,setusername] = useState('Guest')
  const [userid,setuserid] = useState('Guest')

  useEffect(()=>{
  localStorage.setItem('dsrtokenid',dsrtokenid)

   custom_api_func2.get(`api/get-dsruser-id/${dsrtokenid}`)
    .then((response) => {
      setuserid(response.data.userid)
    })

  },[])

  const [taskGroups, setTaskGroups] = useState([]);
  const [settingsGroups, setsettingsGroups] = useState([
    {
    id:'0',
    title: 'User Permission Management'
  },
  {
    id:'1',
    title: 'Additional Fields'
  },
  
  ]);

   useEffect(()=>{
    if (dsrtokenid){
    get_groups_and_tasks()
    all_dsr_users()
   
    setgroup_name(taskGroups[0]?.title || '')
    }
  },[])


  const [statuscolumns,setstatuscolumns] = useState({
    'pending':'#FF9F43',
    'in-progress':'#3742FA',
    'stuck':'#F39C12',
    'done':'#2ECC71',
    'overdue':'red'
  })

  const [useraccesslevelcolors,setuseraccesslevelcolors] = useState({
    'view':'green',
    'edit':'#3742FA',
    'internal':'#F39C12',
  })

  const [allusersnames,setallusersnames] = useState([''])

  const get_groups_and_tasks = () => {
     setloading(true)
    custom_api_func2.get(`api/dsr_get_groups_and_tasks_public/${dsrtokenid}`)
        .then((response) => {
          
          setTaskGroups(response.data.TaskGroups)
          setSelectedGroupId(response.data?.TaskGroups[0].id)
          setgroup_name(response.data?.TaskGroups[0].title)
          getalladdtionalfields()
          setloading(false)
        }).catch((error) => {
           setloading(false)
            //console.log("error", error);
        })
}

  const get_groups_and_tasks2 = () => {
    custom_api_func2.get(`api/dsr_get_groups_and_tasks_public/${dsrtokenid}`)
        .then((response) => {
          setTaskGroups(response.data.TaskGroups)
        }).catch((error) => {
            //console.log("error", error);
        })
}

 
  const all_dsr_users = () => {
    custom_api_func2.get(`api/dsr_get_users_public/${dsrtokenid}`)
        .then((response) => {
          setallusersnames(response.data.users)
        }).catch((error) => {
            //console.log("error", error);
        })
}

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [currentGroup, setCurrentGroup] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedType, setDraggedType] = useState('');
  const [dragOverTarget, setDragOverTarget] = useState(null);

  // Drag and Drop Handlers
  const handleDragStart = (e, item, type) => {
    setDraggedItem(item);
    setDraggedType(type);
    e.dataTransfer.effectAllowed = 'move';
    e.currentTarget.classList.add('dragging');
  };

  const handleDragEnd = (e) => {
    e.currentTarget.classList.remove('dragging');
    setDraggedItem(null);
    setDraggedType('');
    setDragOverTarget(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDragEnter = (e, target) => {
    e.preventDefault();
    setDragOverTarget(target);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setDragOverTarget(null);
    }
  };



  async function updateTaskGroupsOrder(groups) {
  //pass
}

async function updateTasksOrder(tasks) {
  //pss
}


  const handleDrop = async (e, targetGroup, targetColumn, insertIndex) => {
    e.preventDefault();
    setDragOverTarget(null);
    
    if (!draggedItem) return;
    
    if (draggedType === 'task-group') {
      // Handle task group reordering
      const newGroups = [...taskGroups];
      const draggedIndex = newGroups.findIndex(g => g.id === draggedItem.id);
      const targetIndex = insertIndex !== undefined ? insertIndex : newGroups.findIndex(g => g.id === targetGroup?.id);
      
      if (draggedIndex !== -1 && targetIndex !== -1 && draggedIndex !== targetIndex) {
        const [removed] = newGroups.splice(draggedIndex, 1);
        newGroups.splice(targetIndex, 0, removed);

        const updatedGroups = newGroups.map((group, index) => ({
        ...group,
        order_index: index
      }));

        setTaskGroups(updatedGroups);

        try {
        await updateTaskGroupsOrder(updatedGroups); // <-- Implement this function
      } catch (error) {
        console.error('Failed to update task group order:', error);
      }
    

      }
    } else if (draggedType === 'task') {

      // Handle task movement between groups or within same group
      if (targetGroup) {
        const newGroups = [...taskGroups];
        let sourceGroup = null;
        let sourceTaskIndex = -1;
        
        // Find source group and task
        newGroups.forEach((group, groupIndex) => {
          const taskIndex = group.tasks.findIndex(task => task.id === draggedItem.id);
          if (taskIndex !== -1) {
            sourceGroup = group;
            sourceTaskIndex = taskIndex;
          }
        });
        
        if (sourceGroup) {
          // Remove task from source
          const [removedTask] = sourceGroup.tasks.splice(sourceTaskIndex, 1);
          
          // Add to target group at specific position
          const targetGroupObj = newGroups.find(g => g.id === targetGroup.id);
          const targetIndex = insertIndex !== undefined ? insertIndex : targetGroupObj.tasks.length;
          targetGroupObj.tasks.splice(targetIndex, 0, removedTask);
          
          const updatedGroups = newGroups.map(group => ({
          ...group,
          tasks: group.tasks.map((task, index) => ({
            ...task,
            order_index: index
          }))
        }));

          setTaskGroups(updatedGroups);
           try {
          const tasksToUpdate = updatedGroups.flatMap(group => group.tasks);
          await updateTasksOrder(tasksToUpdate); // <-- Implement this function
        } catch (error) {
          console.error('Failed to update task order:', error);
        }

        }
      }
    } 
    
    setDraggedItem(null);
    setDraggedType('');
  };

  // Modal Handlers
  const openModal = (type, group = null) => {
    setModalType(type);
    setCurrentGroup(group);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalType('');
    setCurrentGroup(null);
  };

  // CRUD Operations
  const addTaskGroup = (title) => {
    const newGroup = {
      id: Date.now(),
      title,
      tasks: []
    };
    setTaskGroups([...taskGroups, newGroup]);
  };

  const addTask = (groupId, taskData) => {
    const newGroups = [...taskGroups];
    const groupIndex = newGroups.findIndex(g => g.id === groupId);
    const newTask = {
      id: Date.now(),
      ...taskData,
      status: 'pending'
    };
    newGroups[groupIndex].tasks.push(newTask);
    setTaskGroups(newGroups);
  };


  

const deleteTaskGroup = (groupId) => {
  
  //pass
  }



  // Filtered task groups based on search
  const filteredTaskGroups = taskGroups.filter(group =>
    group.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    group.tasks.some(task => task.title.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // You'll also need to add these state variables to your component:
  const [selectedGroupId, setSelectedGroupId] = useState(taskGroups[0]?.id || 1);
  const [selectedTaskId, setSelectedTaskId] = useState(taskGroups[0]?.tasks[0]?.id || 1);

  
  const [draggedGroupId, setDraggedGroupId] = useState(null);
  const [dragOverGroupIndex, setDragOverGroupIndex] = useState(null);



 const [newMessage, setNewMessage] = useState('');
const chatEndRef = useRef(null);


const [messages, setMessages] = useState([]);

const getallmessages =()=>{
  setloading(true)
  custom_api_func2.get(`api/getalldsrmessages_public/${dsrtokenid}`, )
        .then(response => {
            setMessages(response.data);
        })
        .catch(error => {
            console.log(error);
        });

 }



  const deletemessage = (id) => {
  setloading(true)
    custom_api_func2.get(`api/deletedsrmessages_public/${id}`, )
        .then(response => {
          setMessages(prev => prev.filter(doc => doc.id !== id));
          setloading(false)
        })
        .catch(error => {
          setloading(false)
            console.log(error);
        });
  };

const [searchQuerymessages, setSearchQuerymessages] = useState('');
const [searchTypemessages, setSearchTypemessages] = useState('all'); // 'all', 'content', 'author'
const [showSearchmessages, setShowSearchmessages] = useState(false);

const filteredMessages = useMemo(() => {
    if (!searchQuerymessages.trim()) return messages;

    return messages.filter(message => {
      const query = searchQuerymessages.toLowerCase();
      
      switch (searchTypemessages) {
        case 'content':
          return message.content.toLowerCase().includes(query);
        case 'author':
          return message.author.toLowerCase().includes(query);
        case 'all':
        default:
          return (
            message.content.toLowerCase().includes(query) ||
            message.author.toLowerCase().includes(query)
          );
      }
    });
  }, [messages, searchQuerymessages, setSearchTypemessages]);

const highlightTextmessages = (text, query) => {
    if (!query.trim()) return text;
    
    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
      regex.test(part) ? (
         <mark key={index} style={{ backgroundColor: '#fef08a', padding: '1px 2px', borderRadius: '2px' }}>{part}</mark>
      ) : part
    );
  };

const clearSearchmessages = () => {
  setSearchQuerymessages('');
  setShowSearchmessages(false);
};


 const [documents, setDocuments] = useState([]);
 const [filteredDocuments, setFilteredDocuments] = useState([]);
 const [searchDocument, setsearchDocument] = useState('');

useEffect(() => {
    if (documents.length === 0 || documents.length===null) {
      setFilteredDocuments([]);
    } else {
      const filtered = documents.filter(doc => {
        const matchesSearch = doc.name.toLowerCase().includes(searchDocument.toLowerCase()) ||
                         doc.tags.some(tag => tag.toLowerCase().includes(searchDocument.toLowerCase()));
            return matchesSearch ;
      });
      setFilteredDocuments(filtered);
    }
  }, [documents, searchDocument]);


useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const [mentionQuery, setMentionQuery] = useState('');
  const [cursorPosition, setCursorPosition] = useState(0);
  const chatInputRef = useRef(null);
  const [showUserSuggestions, setShowUserSuggestions] = useState(false);


const handleChatInputChange = (e) => {
    const value = e.target.value;
    const cursorPos = e.target.selectionStart;
    setChatInput(value);
    
    // Check for @ mentions
    const atIndex = value.lastIndexOf('@', cursorPos - 1);
    if (atIndex !== -1 && (atIndex === 0 || value[atIndex - 1] === ' ')) {
      const searchTerm = value.substring(atIndex + 1, cursorPos);
      if (searchTerm.length >= 0) {
        setMentionStart(atIndex);
        setMentionEnd(cursorPos); // Store current cursor position
        setShowUserList(true);
        // Store the search term for filtering
        setCurrentMentionSearch(searchTerm);
      }
    } else {
      setShowUserList(false);
      setMentionStart(-1);
      setMentionEnd(-1);
      setCurrentMentionSearch('');
    }
  };

  const [mentionEnd, setMentionEnd] = useState(-1);

const selectUser = (idx,user) => {
    // Replace from mentionStart to mentionEnd (which was the cursor position when mention started)
    const beforeMention = chatInput.substring(0, mentionStart);
    const afterMention = chatInput.substring(mentionEnd);
    const newValue = beforeMention + '@' + user + ' ' + afterMention;
    setChatInput(newValue);
    setShowUserList(false);
    setMentionStart(-1);
    setMentionEnd(-1);
    setCurrentMentionSearch('');
    settempmentions([...tempmentions,idx])
    
    // Set cursor position after the inserted mention
    setTimeout(() => {
      const newCursorPos = beforeMention.length + user.length + 2; // +2 for '@' and space
      chatInputRef.current.setSelectionRange(newCursorPos, newCursorPos);
      chatInputRef.current.focus();
    }, 0);
  };

const [tempmentions,settempmentions] = useState([])

const sendMessage = () => {
  setShowUserList(false);
  if (chatInput.trim()) {
    
    
    {/*
      const mentions = [];
    
    const mentionRegex = /@(\w+(?:\s\w+)?)/g;
    let match;
    
    while ((match = mentionRegex.exec(chatInput.trim())) !== null) {
      console.log('match',match)
      const user = allusersnames.find(u => u.name === match[1]);
      if (user) mentions.push(user.id);
    }
       */}
    
    const mentions = tempmentions
    settempmentions([])

    
    // Method 2: Alternative - if usernames are properly tagged during insertion
    // You could store mentions differently when they're inserted
    
    
    const formData = new FormData();
    formData.append('author',username)
    formData.append('authorid',userid)
    formData.append('content',chatInput)
    formData.append('mentions',mentions.join(', '))
    custom_api_func2.post(`api/senddsrmessages_public/${dsrtokenid}`, formData, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken,},})
        .then(response => {
            getallmessages()
            if(mentions.length>0){
            const formData = new FormData();
            formData.append('author', username);
            formData.append('taggedid', mentions.join(','));
            custom_api_func2.post(`api/notifyabouttaggedcomment_public/${dsrtokenid}`, formData, 
            {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken,},})
            .then((response) => {
                //pass
            })
        }

        })
        .catch(error => {
            console.log(error);
        });
    
    
    setChatInput('');
  }
};




  const handleMessageChange = (e) => {
    const value = e.target.value;
    const position = e.target.selectionStart;
    
    setNewMessage(value);
    setCursorPosition(position);

    // Check for @ mention
    const textBeforeCursor = value.substring(0, position);
    const lastAtIndex = textBeforeCursor.lastIndexOf('@');
    
    if (lastAtIndex !== -1) {
      const textAfterAt = textBeforeCursor.substring(lastAtIndex + 1);
      if (!textAfterAt.includes(' ')) {
        setMentionQuery(textAfterAt);
        setShowUserSuggestions(true);
        return;
      }
    }
    
    setShowUserSuggestions(false);
    setMentionQuery('');
  };




  
  
  
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);


  const getFileIcon = (type) => {
    switch (type.toLowerCase()) {
      case 'pdf': return <FileText color={'#b91c1c'} size={22} />;
      case 'doc': return <FileText color={'#6d28d9'} size={22} />;
      case 'link': return <Link color={'#4b5563'} size={22} />;
      case 'xlsx': case 'xls': case 'csv': case 'spreadsheet': return <FileSpreadsheet color={'#15803d'} size={22} />;
      case 'jpg': case 'jpeg': case 'png': case 'gif': case 'image': return <FileImage color={'#1d4ed8'} size={22} />;
      case 'mp4': case 'avi': case 'mov': case 'video': return <FileVideo color={'#6d28d9'} size={22} />;
      case 'mp3': case 'wav': case 'audio': return <FileAudio color={'#b45309'} size={22} />;
      case 'zip': case 'rar': return <Archive color={'#4b5563'} size={22} />;
      default: return <File color={'#4b5563'} size={22} />;
    }
  };

  const handleDocumentDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDocumentDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    console.log('xxsxsxherexsxsx')
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFiles(e.dataTransfer.files);
    }
  };

  
 const getalldocuments =()=>{
  setloading(true)
  custom_api_func2.get(`api/getalldsrdocuments_public/${dsrtokenid}`, )
        .then(response => {
            setDocuments(response.data);
            setloading(false)
        })
        .catch(error => {
            console.log(error);
            setloading(false)
        });

 }


 
  const handleFiles = (files) => {
    Array.from(files).forEach(file => {
      const newDoc = {
        id: Date.now() + Math.random(),
        name: file.name,
        type: file.type.split('/')[1] || 'unknown',
        uploadDate: new Date().toISOString().split('T')[0],
        uploadedBy: username,
        uploadedByid: userid,
        file: file
      }; 
    
    const formData = new FormData();
    
    formData.append('name',file.name)
    formData.append('type',file.type.split('/')[1] || 'unknown')
    formData.append('uploadDate',new Date().toISOString().split('T')[0])
    formData.append('uploadedBy',username)
    formData.append('uploadedByid',userid)
    formData.append('csmplanfiles',file)


    custom_api_func2.post(`api/uploaddsrdocuments_public/${dsrtokenid}`, formData, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken,},})
        .then(response => {
            toast.success("Upload Successfull");
            newDoc.id = response.data['id']
            setDocuments(prev => [newDoc, ...prev]);
            //window.location.reload(false)
        })
        .catch(error => {
            console.log(error);
        });

    });
  };
  
  const downloadDocument = (url) => {
    window.open('https://api.successguardian.in/media/'+ url, '_blank');
  };

  const deleteDocument = (id) => {
    custom_api_func2.get(`api/deletedsrdocuments_public/${id}`, )
        .then(response => {
          setDocuments(prev => prev.filter(doc => doc.id !== id));
        })
        .catch(error => {
            console.log(error);
        });
  };

const formatMessageContent = (content, mentions = []) => {
  if (!mentions || mentions.length === 0) {
    return content;
  }
  
  let formattedContent = content;

  mentions.forEach(mention => {
    // Replace all instances of @mention with formatted version
    formattedContent = formattedContent.replaceAll(`@${mention.name}`, `<span class="mention">@${mention.name}</span>`);
  });
  
  return formattedContent;
};

  const [chatInput, setChatInput] = useState('');


  const [mentionStart, setMentionStart] = useState(-1);
  const [showUserList, setShowUserList] = useState(false);


  const [currentMentionSearch, setCurrentMentionSearch] = useState('');

  
  const [addtask,setaddtask] = useState(false)
  const [edittask,setedittask] = useState(false)

  const [task_type,settask_type] = useState("")
  const [task_name,settask_name] = useState("")
  const [task_user,settask_user] = useState("")
  const [task_status,settask_status] = useState("")
  const [task_priority,settask_priority] = useState("")
  const [task_due_date,settask_due_date] = useState("")
  const [task_created_date,settask_created_date] = useState("")
  const [task_note,settask_note] = useState("")
  const [task_id,settask_id] = useState(null)


  const [addgroup,setaddgroup] = useState("")
  const [group_name,setgroup_name] = useState("")

  const [updategroup,setupdategroup] = useState("")

  const get_expanded_view2 = (taskid) => {
    custom_api_func2.get(`api/dsr_get_expanded_view_public/${taskid}`).then((response) => {
        settask_note(response.data.description)
  }).catch ((error)  => {
    //console.log('error',error)
  })
  }

  const [showActionsDropdown, setShowActionsDropdown] = useState(false);
  const [showsavetemplate,setshowsavetemplate] = useState(false);
  const [title,setTitle] = useState("")

  const [showoverridetemplate,setshowoverridetemplate] = useState(false);
  const [alltemplates,setalltemplates] = useState([])
  const [templateid,settemplateid] = useState("")

  const [showuploadcsvcsplan,setshowuploadcsvcsplan] = useState(false);
  const [data_file, setdata_file] = useState('');
  const [columnNames, setColumnNames] = useState([]);
  const [columnMapping, setcolumnMapping] = useState([]);

  const handleFileChange = (event) => {
        const file = event.target.files[0];
      
        if (file) {
          const fileExtension = file.name.split('.').pop().toLowerCase();
      
          if (fileExtension === 'csv') {
            Papa.parse(file, {
              header: true,
              complete: (result) => {
                const parsedData = result.data;
                if (!parsedData || parsedData.length === 0) { toast.error('Empty or invalid CSV file.'); return; }
                setColumnNames(Object.keys(parsedData[0]));
                setdata_file(parsedData);
              },
              error: (error) => {
                console.error('Error parsing CSV:', error.message);
                toast.error('Error parsing CSV. Please check the file format.');
              },
            });
          } else if (['xls', 'xlsx', 'numbers'].includes(fileExtension)) {
            const reader = new FileReader();
            reader.onload = (event) => {
              const data = new Uint8Array(event.target.result);
              const workbook = XLSX.read(data, { type: 'array' });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];
              const parsedData = XLSX.utils.sheet_to_json(worksheet);
              if (!parsedData || parsedData.length === 0) { toast.error('Empty or invalid Excel file.'); return; }
              setColumnNames(Object.keys(parsedData[0]));
              setdata_file(parsedData);
            };
            reader.onerror = (error) => {
              console.error('Error reading file:', error.message);
              toast.error('Error reading Excel file. Please check the file format.');
            };
            reader.readAsArrayBuffer(file);
          } else {
            toast.error('Invalid file type. Please upload a CSV, Excel, or Numbers file.');
          }
        } else {
          toast.error('No file selected. Please upload a valid file.');
        }
      };

  const handleMappingChange = (columnName, attributeName) => {
      setcolumnMapping({ ...columnMapping, [columnName]: attributeName });
    };
  
  const [availablecolumns,setavailablecolumns] = useState([
            {
              "val": "Status",
              "type": "dropdown-column",
              "options": [
                {"color": "#00c875","title": "Done"},
                {"color": "#fdab3d","title": "In Progress"},
                {"color": "#e2445c","title": "Stuck"},
                {"color": "#c4c4c4","title": "Not Started Yet"}
              ]
            },
            {"val": "Person","type": "member-column"},
            {"val": "Date","type": "date-column"},
            {
              "val": "Priority",
              "type": "dropdown-column",
              "options": [
                {"color": "#ffcb00","title": "Low"},
                {"color": "#a25ddc","title": "Medium"},
                {"color": "#e2445c","title": "High"},
                {"color": "#c4c4c4","title": "Not Assigned"}
              ]
            },
            {"val": "Last Updated","type": "time-column"}
          ])
  
  const chatMessagesRef = useRef(null);
const [isLoadingOlderMessages, setIsLoadingOlderMessages] = useState(false);


useEffect(() => {
  if (chatMessagesRef.current && !isLoadingOlderMessages) {
    chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
  }
}, [messages]);

useEffect(() => {
  if (isLoadingOlderMessages && chatMessagesRef.current) {
    const scrollContainer = chatMessagesRef.current;
    const currentScrollHeight = scrollContainer.scrollHeight;
    const savedScrollHeight = scrollContainer.scrollHeight;
    
    const adjustScroll = () => {
      if (scrollContainer.scrollHeight > savedScrollHeight) {
        const heightDifference = scrollContainer.scrollHeight - savedScrollHeight;
        scrollContainer.scrollTop = heightDifference;
        setIsLoadingOlderMessages(false);
      } else {
        requestAnimationFrame(adjustScroll);
      }
    };
    
    requestAnimationFrame(adjustScroll);
  }
}, [messages, isLoadingOlderMessages]);

const [showLoadMore, setShowLoadMore] = useState(false);

const handleScroll = () => {
  if (chatMessagesRef.current) {
    const { scrollTop, scrollHeight, clientHeight } = chatMessagesRef.current;
    const isScrollable = scrollHeight > clientHeight;
    const isNearTop = scrollTop < 50;
    const shouldShow = messages.length > 0 && (!isScrollable || isNearTop);
    setShowLoadMore(shouldShow);
  }
};

useEffect(() => {
  handleScroll();
}, [messages]);

const [timingint,settimingint] = useState(1)

const loadMoreMessages = () => {
  if (!chatMessagesRef.current) return;
  setIsLoadingOlderMessages(true);
  
  custom_api_func2.get(`api/getalldsrmessagesloadmore_public/${dsrtokenid}/${timingint}`)
  .then(response => {
    setMessages(prevMessages => [...response.data, ...prevMessages]);
    setShowLoadMore(false);
    settimingint(prev => prev + 1);
    toast.success("More Messages Loaded. If you don't see more messages, there might be no more messages")
  })
  .catch(error => {
    console.log(error);
    setShowLoadMore(true);
    setIsLoadingOlderMessages(false);
  });
  
  console.log('Loading more older messages...');
};


// Analytics
const [formData, setFormData] = useState({
    blockName: '',
    chartType: '',
    attribute_id: '',
    groupby_id: '',
    customer_id: '',
    attribute_agg:'',
    attribute_timeline:'',
    attribute_timeline_agg:'',
    chartColor: '#000000'
  });

  const [ShowAddKPIForm,setShowAddKPIForm] = useState(false)
  const [ShowEditKPIForm,setShowEditKPIForm] = useState(false)
  const [attributes, setattributes] = useState([]); 
  const [group_attributes, setgroup_attributes] = useState([]); 

  const fetchDSRlist = () => {
        custom_api_func2.get(`api/get_dsr_list_public`).then((response) => {
        setattributes(response.data['attributes']);
        setgroup_attributes(response.data['group_attributes']);
    }).catch ((error)  => {
        console.error('Error fetching segments:', error);
    });
}


  const [blocks, setblocks] = useState([]);

  const delete_KPI = (chart_id) =>{
    //pass
  }

  
const [object_id,setobject_id]= useState(null);
const get_chart = (chart_id) => {
  setloading(true)
  custom_api_func2.get(`api/get_dsr_chart_public/${chart_id}`).then((response) => {
      formData.blockName = response.data.data.blockName
      formData.chartType = response.data.data.chartType
      formData.attribute_id = response.data.data.attribute_id
      formData.groupby_id = response.data.data.groupby_id
      formData.attribute_agg = response.data.data.attribute_agg
      formData.attribute_timeline = response.data.data.attribute_timeline
      formData.attribute_timeline_agg = response.data.data.attribute_timeline_agg
      formData.chartColor = response.data.data.chartColor
      setShowEditKPIForm(true)
      setloading(false)
      setobject_id(chart_id)
  })
    .catch((error) => {
      setloading(false)
      toast.error("Error Occured ",error);
    });
  }

useEffect(()=>{
  if (activeTab === 'analytics' && dsrtokenid){
    fetch_analytics()
  }
  },[activeTab])

const fetch_analytics = () => {
  senteventdata('fetch_analytics_public API Called React-js','')
  setloading(true)
  custom_api_func2.get(`api/fetch_analytics_public/${dsrtokenid}`).then((response) => {
      if (response.data.blocks?.length>0){
        setblocks(response.data.blocks)
        setloading(false)
      }
      else{
        setblocks([])
        setloading(false)
      }
    }).catch ((error)  => {
      toast.error('Error fetching Analytics')
      setblocks([])
      setloading(false)
      console.error('Error fetching blocks:', error);
    });
  }


  const handle_KPI_edit = (chart_id) =>{
    get_chart(chart_id)
  }

  const updateBlockPosition = (block_id, x, y, width, height) => {
  //pass
  };
  
  const [opendrownanalytics,setopendrownanalytics] = useState(false)
  const [editingblocks, seteditingblocks] = useState(false);

  const [allknowledgebase,setknowledgebase] = useState([])
  const getallknowledgebase = () => {
    setloading(true)
    custom_api_func2.get(`api/getdsrallknowledgebase_public/${dsrtokenid}`, )
        .then(response => {
            setknowledgebase(response.data);
            setloading(false)
        })
        .catch(error => {
          setloading(false)
            console.log(error);
        });
  }

  const [allavailablekbtags,setallavailablekbtags] = useState([
    {'id':'0','key':'0','value':'A'},
    {'id':'1','key':'1','value':'B'},
    {'id':'2','key':'2','value':'C'}
  ])
  const getallavailablekbtags = () => {
    custom_api_func2.get(`api/getallavailablekbtags_public/${dsrtokenid}`, )
        .then(response => {
            setallavailablekbtags(response.data);
        })
        .catch(error => {
            console.log(error);
        });
  }

  const deleteknowledgebaseresource = (uid) => {
    custom_api_func2.get(`api/deletedsrknowledgebase_public/${uid}`, )
        .then(response => {
            setknowledgebase(prev => prev.filter(doc => doc.id !== uid));
        })
        .catch(error => {
            console.log(error);
        });
  }

  const [showkb,setshowkb] = useState(false)
  const [kbfilename,setkbfilename] = useState('')
  const [kbdescription,setkbdescription] = useState('')
  const [kbtags,setkbtags] = useState('')
  const [kburl,seturl] = useState('')
  const [kbfiles,setkbfiles] = useState(null)
  const kbfileInputRef = useRef(null);

  const [searchknowledgebase,setsearchknowledgebase] = useState('')
  const allTags = [...new Set(allknowledgebase.flatMap(item => item.tags))];
  const [selectedTags, setSelectedTags] = useState([]);

  const getTypeColor = (type) => {
    const colors = { pdf:'#b91c1c', video:'#b45309', image:'#15803d', sheet:'#0e7490', doc:'#6d28d9', link:'#4338ca' };
    return colors[type] || '#4b5563';
  };

  const filteredknowledgebase = useMemo(() => {
    let filtered = allknowledgebase;

    if (searchknowledgebase) {
      filtered = filtered.filter(item =>
        item.title.toLowerCase().includes(searchknowledgebase.toLowerCase()) ||
        item.description.toLowerCase().includes(searchknowledgebase.toLowerCase()) ||
        item.tags.some(tag => tag.toLowerCase().includes(searchknowledgebase.toLowerCase()))
      );
    }

    if (selectedTags.length > 0) {
      filtered = filtered.filter(item =>
        selectedTags.some(tag => item.tags.includes(tag))
      );
    }

    filtered.sort((a, b) => {
      return new Date(b.dateAdded) - new Date(a.dateAdded);
    });

    return filtered;
  }, [allknowledgebase,searchknowledgebase, selectedTags]);

  const [showFilters,setShowFilters] = useState(false)

  const toggleTag = (tag) => {
    setSelectedTags(prev =>
      prev.includes(tag)
        ? prev.filter(t => t !== tag)
        : [...prev, tag]
    );
  };

  const [alladdtionalfields,setalladdtionalfields]= useState([{
    id:0,
    name:'CSCS',
    selectedgroup:'all',
    type:'text',
    options:[]
  },{
    id:1,
    name:'detdate',
    selectedgroup:'all',
    type:'date',
    options:[]
  },{
    id:2,
    name:'MX',
    selectedgroup:'all',
    type:'multiple choice',
    options:[]
  },{
    id:3,
    name:'SX',
    selectedgroup:'all',
    type:'single choice',
    options:[]
  }])

  const getalladdtionalfields = () => {
      custom_api_func2.get(`api/getalladdtionalfields_public/${dsrtokenid}`, )
        .then(response => {
            setalladdtionalfields(response.data);
        })
        .catch(error => {
            console.log(error);
        });
    }
  
  const [showeaddddtionalfield,setshowaddaddtionalfield] = useState(false)
  const [showeditaddtionalfield,setshoweditaddtionalfield] = useState(false)
  
  const [field_name,setfield_name] = useState('')
  const [field_type,setfield_type] = useState('text')
  const [field_options,setfield_options] = useState([])
  const [field_selected_group,setfield_selected_group] = useState('all')

  const [selected_field_id,setselected_field_id] = useState(null)

  const [alladdtionalfieldsvalues,setalladdtionalfieldsvalues] = useState([])
  const get_additional_all_field_values = (taskid) => {
    custom_api_func2.get(`api/get_additional_field_values_public/${dsrtokenid}/${taskid}`, )
      .then(response => {
          setalladdtionalfieldsvalues(response.data);
      })
      .catch(error => {
          console.log(error);
      });
  }
  
  const [viewMode, setViewMode] = useState('list');
  const [viewtask,setviewtask] = useState(false)

  // ─────────── STYLE TOKENS ───────────
  const T = {
    accent: '#4338ca',
    accent2: '#6d28d9',
    tableHeaderAccent: '#3730a3',
    bg: '#f3f4f6',
    border: '#d1d5db',
    borderMed: '#9ca3af',
    textPrimary: '#111827',
    textSecondary: '#1f2937',
    textMuted: '#4b5563',
    white: '#ffffff',
  };

  const btnPrimary = {
    display:'flex', alignItems:'center', gap:'5px',
    padding:'0 14px', height:'32px', fontSize:'13px', fontWeight:'650',
    backgroundColor:T.accent, color:T.white, border:'none', borderRadius:'8px',
    cursor:'pointer', boxShadow:'0 2px 8px rgba(67,56,202,0.40)',
    transition:'all 0.15s', fontFamily:'Inter,system-ui,sans-serif',
  };

  const btnSecondary = {
    display:'flex', alignItems:'center', gap:'5px',
    padding:'0 14px', height:'32px', fontSize:'13px', fontWeight:'500',
    backgroundColor:T.white, color:'#374151', border:`1.5px solid ${T.borderMed}`,
    borderRadius:'8px', cursor:'pointer', transition:'all 0.15s', fontFamily:'Inter,system-ui,sans-serif',
  };

  // ─────────── TABS CONFIG ───────────
  const tabs = [
    {
      id: 'success-plan',
      label: 'Success Plan',
      icon: Home,
      onClick: () => {
        setSelectedGroupId(taskGroups[0]?.id);
        setgroup_name(taskGroups[0]?.title);
        getalladdtionalfields();
        setActiveTab('success-plan');
      }
    },
    {
      id: 'analytics',
      label: 'Analytics',
      icon: TrendingUp,
      onClick: () => {
        fetch_analytics();
        setActiveTab('analytics');
      }
    },
    {
      id: 'documents',
      label: 'Documents',
      icon: Files,
      onClick: () => {
        getalldocuments();
        setActiveTab('documents');
      }
    },
    {
      id: 'knowledge-base',
      label: 'Knowledge Base',
      icon: BringToFront,
      onClick: () => {
        getallknowledgebase();
        setActiveTab('knowledge-base');
      }
    },
    {
      id: 'updates',
      label: 'Updates',
      icon: MessageCircleMore,
      onClick: () => {
        getallmessages();
        setActiveTab('updates');
      }
    }
  ];

  // ─────────── ANALYTICS HELPERS ───────────
  const totalTasks = taskGroups.reduce((sum, group) => sum + group.tasks.length, 0);
  const completedTasks = taskGroups.reduce((sum, group) =>
    sum + group.tasks.filter(t => t.status === 'done').length, 0
  );
  const overallProgress = totalTasks ? Math.round((completedTasks / totalTasks) * 100) : 0;
  const activeGroups = taskGroups.filter(group =>
    group.tasks.some(t => t.status !== 'done')
  ).length;

  const [expandedGroups, setExpandedGroups] = useState(new Set([1, 2]));
  const [expandedDocs, setExpandedDocs] = useState(new Set());
  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => {
      const newSet = new Set(prev);
      if (newSet.has(groupId)) { newSet.delete(groupId); } else { newSet.add(groupId); }
      return newSet;
    });
  };

  const toggleDocumentation = (taskId) => {
    setExpandedDocs(prev => {
      const newSet = new Set(prev);
      if (newSet.has(taskId)) { newSet.delete(taskId); } else { newSet.add(taskId); }
      return newSet;
    });
  };

  const getDependencyNames = (task, allTaskGroups) => {
    const allTasks = allTaskGroups.flatMap(group => group.tasks);
    return task.dependencies
      .map(depId => allTasks.find(t => t.id === depId)?.title)
      .filter(Boolean);
  };

  const statusOptions = ['pending', 'in-progress', 'done', 'overdue'];
  const getStatusColor = (status) => {
    const colors = {
      'pending': { backgroundColor: '#fef3c7', color: '#92400e' },
      'in-progress': { backgroundColor: '#e0e7ff', color: '#3730a3' },
      'done': { backgroundColor: '#dcfce7', color: '#15803d' },
      'overdue': { backgroundColor: '#fee2e2', color: '#b91c1c' }
    };
    return colors[status] || colors.pending;
  };
  
  const isTaskLocked = (task, groupId) => {
    if (!task.dependencies || task.dependencies.length === 0) return false;
    const allTasks = taskGroups.flatMap(group => group.tasks);
    return task.dependencies.some(depId => {
      const depTask = allTasks.find(t => t.id === depId);
      return !depTask || depTask.status !== 'done';
    });
  };

  const renderFieldInput = (group, task, field) => {
    const currentValue = task.additional_fields?.[field.name] || (field.type === 'multiple_choice' ? [] : '');
    return currentValue ? (
      <div style={{ width:'100%', maxWidth:'120px', padding:'4px 8px', border:'1px solid #d1d5db', borderRadius:'4px', fontSize:'12px', backgroundColor:'#f9fafb' }}>
        {currentValue}
      </div>
    ) : null;
  };

  return (
    <>
      <style>{`
        *, *::before, *::after { box-sizing: border-box; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }
        :root { color-scheme: light; }
        @keyframes slideUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
        @keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
        ::-webkit-scrollbar { width:4px; height:4px; }
        ::-webkit-scrollbar-track { background:transparent; }
        ::-webkit-scrollbar-thumb { background:#d1d5db; border-radius:4px; }
        * { scrollbar-width: thin; scrollbar-color: #d1d5db transparent; }
        .dsr-nav-item:hover { background:#eef2ff !important; color:#4338ca !important; }
        .dsr-nav-item.active { background:#e0e7ff !important; color:#3730a3 !important; font-weight:650 !important; }
        .dsr-table-row:hover { background:#f5f3ff !important; }
        .dsr-card:hover { box-shadow:0 4px 24px rgba(0,0,0,0.10) !important; border-color:#c7d2fe !important; }
        .dsr-btn-primary:hover { background:#3730a3 !important; transform:translateY(-1px); }
        .dsr-btn-secondary:hover { border-color:#4338ca !important; color:#4338ca !important; }
        .dsr-input:focus { border-color:#4338ca !important; outline:2px solid #4338ca !important; outline-offset:2px !important; }
        .mention { background:#e0e7ff; color:#4338ca; border-radius:4px; padding:1px 5px; font-weight:600; }
      `}</style>
      <Toaster />

      <SkeletonWrapper
              loading={loading}
              showProgress={true}
              showIcon={true}
              icon="https://api.successguardian.in/media/logo_sg_small.png"
              accentColor="#6366f1"
              staggerDelay={60}
            >
        <div style={{ fontFamily:"'Inter', system-ui, sans-serif", backgroundColor:T.bg, minHeight:'100vh', display:'flex', flexDirection:'column', zoom:'95%', WebkitFontSmoothing:'antialiased', MozOsxFontSmoothing:'grayscale', animation:'fadeIn 0.4s ease' }}>

          {/* ── STICKY TOP NAV BAR ── */}
          <header style={{ backgroundColor:T.white, borderBottom:`1px solid ${T.border}`, padding:'0 24px', height:'54px', display:'flex', justifyContent:'space-between', alignItems:'center', position:'sticky', top:0, zIndex:100 }}>
            <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
              <div style={{ background:'linear-gradient(135deg,#4338ca,#6d28d9)', width:'29px', height:'29px', borderRadius:'8px', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                <Target size={16} color="white" />
              </div>
              <span style={{ fontSize:'15px', fontWeight:'700', color:T.textPrimary, letterSpacing:'-0.3px' }}>Digital Success Room</span>
            </div>
          </header>

          {/* ── TWO-COLUMN LAYOUT ── */}
          <div style={{ display:'flex', flex:1, minHeight:0 }}>

            {/* ── LEFT SIDEBAR ── */}
            <div style={{ width:'205px', flexShrink:0, backgroundColor:T.white, borderRight:`1px solid ${T.border}`, display:'flex', flexDirection:'column', padding:'12px 10px 16px 10px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 4px 8px 4px', marginBottom:'4px', borderBottom:`1px solid ${T.border}` }}>
                <span style={{ fontSize:'10px', fontWeight:'600', color:T.textMuted, textTransform:'uppercase', letterSpacing:'0.08em' }}>Navigation</span>
              </div>
              <nav style={{ display:'flex', flexDirection:'column', gap:'2px', flex:1 }}>
                {tabs.map((tab) => {
                  const Icon = tab.icon;
                  const isActive = activeTab === tab.id;
                  return (
                    <button
                      key={tab.id}
                      className={`dsr-nav-item${isActive?' active':''}`}
                      onClick={tab.onClick}
                      style={{ display:'flex', alignItems:'center', gap:'8px', width:'100%', padding:'8px 10px', borderRadius:'7px', border:'none', cursor:'pointer', fontSize:'13px', fontWeight: isActive?'650':'500', color: isActive?T.tableHeaderAccent:T.textSecondary, backgroundColor: isActive?'#e0e7ff':'transparent', textAlign:'left', transition:'all 0.15s', fontFamily:"'Inter',system-ui,sans-serif" }}
                    >
                      <Icon size={15} />
                      {tab.label}
                    </button>
                  );
                })}
              </nav>
            </div>

            {/* ── MAIN CONTENT ── */}
            <div style={{ flex:1, minWidth:0, display:'flex', flexDirection:'column' }}>

              {/* Board header strip */}
              <div style={{ padding:'16px 22px', backgroundColor:T.white, borderBottom:`1px solid ${T.border}`, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div>
                  <h1 style={{ fontSize:'18px', fontWeight:'780', letterSpacing:'-0.5px', color:T.textPrimary, margin:0, lineHeight:'1.2' }}>
                    {tabs.find(t => t.id === activeTab)?.label}
                  </h1>
                  <p style={{ margin:0, fontSize:'12px', color:T.textMuted, marginTop:'2px' }}>
                    {activeTab === 'success-plan' && 'View tasks, groups, and progress'}
                    {activeTab === 'analytics' && 'Track KPIs and overall progress'}
                    {activeTab === 'documents' && 'Upload and manage shared files'}
                    {activeTab === 'knowledge-base' && 'Curated resources and references'}
                    {activeTab === 'updates' && 'Team messages and mentions'}
                  </p>
                </div>

                {activeTab === 'updates' && (
                  <button
                    className="dsr-btn-secondary"
                    style={btnSecondary}
                    onClick={() => setShowSearchmessages(!showSearchmessages)}
                    onMouseEnter={(e) => { e.currentTarget.style.borderColor='#4338ca'; e.currentTarget.style.color='#4338ca'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color='#374151'; }}>
                    <Search size={13} /> Search
                  </button>
                )}
              </div>

              {/* ── TAB CONTENT ── */}
              <div style={{ flex:1, overflowY:'auto', padding:'24px', animation:'slideUp 0.25s ease' }}>

                {/* ═══ SUCCESS PLAN ═══ */}
                {activeTab === 'success-plan' && (
                  <div style={{ backgroundColor:T.white, borderRadius:'10px', border:`1px solid #e5e7eb`, boxShadow:'0 1px 4px rgba(0,0,0,0.06)', overflow:'hidden' }}>
                    {taskGroups.map((group, groupIndex) => (
                      <div key={group.id} style={{ borderBottom: groupIndex === taskGroups.length-1 ? 'none' : `2px solid #f1f5f9` }}>
                        {/* Group header */}
                        <div style={{ backgroundColor:'#f9fafb', padding:'12px 20px', borderBottom: expandedGroups.has(group.id) ? `1px solid #e5e7eb` : 'none' }}>
                          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                            <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                              <button onClick={() => toggleGroup(group.id)} style={{ color:T.textMuted, cursor:'pointer', border:'none', background:'none', display:'flex', padding:'2px' }}>
                                {expandedGroups.has(group.id) ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                              </button>
                              <span style={{ fontSize:'15px', fontWeight:'600', color:T.textPrimary }}>
                                {group.title}
                              </span>
                              <span style={{ fontSize:'11px', backgroundColor:'#e0e7ff', color:'#3730a3', padding:'2px 8px', borderRadius:'20px', fontWeight:'600' }}>
                                {group.tasks.length} tasks
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Expanded group tasks table */}
                        {expandedGroups.has(group.id) && (
                          <div>
                            <div style={{ overflowX:'auto' }}>
                              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                                <thead>
                                  <tr style={{ backgroundColor:T.tableHeaderAccent }}>
                                    {['Task','Owner','Status', ...group.additional_fields.map(f=>f.name)].map((col,i) => (
                                      <th key={i} style={{ textAlign:'left', padding:'14px', fontWeight:'700', color:T.white, fontSize:'11px', textTransform:'uppercase', letterSpacing:'0.05em', whiteSpace:'nowrap', minWidth: col==='Task'?'240px': col==='Owner'?'140px': col==='Status'?'120px': '130px' }}>{col}</th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {group.tasks.map((task) => {
                                    const isLocked = isTaskLocked(task, group.id);
                                    const isDocExpanded = expandedDocs.has(task.id);
                                    return (
                                      <React.Fragment key={task.id}>
                                        <tr className="dsr-table-row"
                                          style={{ borderTop:`1px solid #e5e7eb`, backgroundColor:T.white, opacity: isLocked ? 0.6 : 1 }}>

                                          <td style={{ padding:'10px 14px' }}>
                                            <div style={{ display:'flex', alignItems:'flex-start', gap:'7px' }}>
                                              {isLocked && <span title="Locked">🔒</span>}
                                              <div style={{ flex:1 }}>
                                                <div style={{ fontWeight:'500', color:T.textPrimary, fontSize:'13px' }}>{task.title}</div>
                                                {task.description && <div style={{ fontSize:'11px', color:T.textMuted, marginTop:'2px' }}>{task.description}</div>}
                                                {task.dependencies.length > 0 && (
                                                  <div style={{ fontSize:'11px', color:T.textMuted, marginTop:'3px', display:'flex', alignItems:'center', gap:'3px', flexWrap:'wrap' }}>
                                                    <Link size={9} /><span>Depends on:</span>
                                                    {getDependencyNames(task, taskGroups).map((depTitle, i) => (
                                                      <span key={i} style={{ backgroundColor:'#f3f4f6', padding:'1px 6px', borderRadius:'4px', fontSize:'10px' }}>{depTitle}</span>
                                                    ))}
                                                  </div>
                                                )}
                                                {task.documentation && (
                                                  <button style={{ display:'inline-flex', alignItems:'center', fontSize:'11px', color:T.accent, fontWeight:'500', cursor:'pointer', border:'none', background:'none', gap:'3px', padding:'2px 0', marginTop:'3px' }}
                                                    onClick={() => toggleDocumentation(task.id)}>
                                                    <FileText size={9} />
                                                    {isDocExpanded ? 'Hide Docs' : 'View Docs'}
                                                  </button>
                                                )}
                                              </div>
                                            </div>
                                          </td>

                                          <td style={{ padding:'10px 14px' }}>
                                            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                                              <div style={{ width:'26px', height:'26px', backgroundColor:'#6d28d9', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', color:T.white, fontSize:'11px', fontWeight:'600', flexShrink:0 }}>
                                                {(allusersnames.find(user => user.id === task.assignee)?.name || 'U').charAt(0).toUpperCase()}
                                              </div>
                                              <span style={{ fontSize:'12px', color:T.textSecondary }}>
                                                {allusersnames.find(user => user.id === task.assignee)?.name || 'Unassigned'}
                                              </span>
                                            </div>
                                          </td>



                                          <td style={{ padding:'10px 14px' }}>
                                            <select value={task.status}
                                              disabled={isLocked} 
                                              className="dsr-input form-select"
                                              style={{ padding:'5px 10px', paddingRight: '28px', borderRadius:'6px', fontSize:'12px', fontWeight:'600', WebkitAppearance:'none', MozAppearance:'none', appearance:'none', backgroundImage:"url(\"data:image/svg+xml;utf8,<svg fill='none' stroke='%234b5563' stroke-width='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/></svg>\")", backgroundRepeat:'no-repeat', backgroundPosition:'right 8px center', backgroundSize:'12px', cursor: isLocked ? 'not-allowed' : 'default', border:`1.5px solid ${T.borderMed}`, ...getStatusColor(task.status) }}>
                                              {statusOptions.map(status => (
                                                <option key={status} value={status}>{status.charAt(0).toUpperCase()+status.slice(1).replace('-',' ')}</option>
                                              ))}
                                            </select>
                                          </td>

                                          {group.additional_fields.map(field => (
                                            <td key={field.name} style={{ padding:'10px 14px' }}>
                                              {renderFieldInput(group, task, field)}
                                            </td>
                                          ))}
                                        </tr>

                                        {isDocExpanded && task.documentation && (
                                          <tr>
                                            <td colSpan={8 + (group.additional_fields?.length||0)} style={{ padding:'0 14px 10px 14px' }}>
                                              <div style={{ background:'linear-gradient(to right,#eff6ff,#eef2ff)', border:`1px solid #c7d2fe`, borderRadius:'8px', padding:'12px', marginLeft:'28px', boxShadow:'0 1px 3px rgba(0,0,0,0.06)' }}>
                                                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'8px' }}>
                                                  <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                                                    <div style={{ width:'6px', height:'6px', backgroundColor:T.accent, borderRadius:'50%' }} />
                                                    <h4 style={{ fontSize:'12px', fontWeight:'700', color:'#1e3a8a', margin:0 }}>Documentation</h4>
                                                  </div>
                                                  <button style={{ color:'#60a5fa', cursor:'pointer', border:'none', background:'none', padding:'2px', display:'flex' }}
                                                    onClick={() => toggleDocumentation(task.id)}>
                                                    <X size={13} />
                                                  </button>
                                                </div>
                                                <div className="quill-editor">
                                                  <RichTextEditor value={task.documentation} view_only={true} placeholder="" />
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}

                    {(!taskGroups || taskGroups.length === 0) && (
                      <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'64px 24px', animation:'fadeIn 0.4s ease' }}>
                        <div style={{ width:'56px', height:'56px', backgroundColor:'#e5e7eb', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:'16px' }}>
                          <Target size={24} color={T.textMuted} />
                        </div>
                        <h3 style={{ margin:'0 0 8px 0', fontSize:'16px', fontWeight:'700', color:T.textPrimary }}>No Groups Available</h3>
                        <p style={{ margin:0, fontSize:'13px', color:T.textMuted, textAlign:'center' }}>No groups have been added yet.</p>
                      </div>
                    )}
                  </div>
                )}

                {/* ═══ ANALYTICS ═══ */}
                {activeTab === 'analytics' && (
                  <div style={{ animation:'slideUp 0.25s ease' }}>
                    {/* Summary cards */}
                    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))', gap:'16px', marginBottom:'24px' }}>
                      {[
                        { label:'Total Tasks', value:totalTasks, color:'#4338ca' },
                        { label:'Completed', value:completedTasks, color:'#15803d' },
                        { label:'Overall Progress', value:`${overallProgress}%`, color:'#4338ca' },
                        { label:'Active Groups', value:activeGroups, color:'#6d28d9' },
                      ].map((card, i) => (
                        <div key={i} className="dsr-card"
                          style={{ backgroundColor:T.white, border:`1px solid #e5e7eb`, borderRadius:'10px', padding:'20px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', textAlign:'center' }}>
                          <div style={{ fontSize:'11px', fontWeight:'600', color:T.textMuted, textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'6px' }}>{card.label}</div>
                          <div style={{ fontSize:'28px', fontWeight:'780', color:card.color, letterSpacing:'-0.5px' }}>{card.value}</div>
                        </div>
                      ))}
                    </div>

                    {/* Progress overview */}
                    <div style={{ backgroundColor:T.white, borderRadius:'10px', border:`1px solid #e5e7eb`, padding:'24px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', marginBottom:'24px' }}>
                      <h3 style={{ margin:'0 0 20px 0', fontSize:'15px', fontWeight:'700', color:T.textPrimary, display:'flex', alignItems:'center', gap:'8px' }}>
                        <BarChart3 size={18} color={T.accent} /> Success Plan Progress Overview
                      </h3>
                      {taskGroups.map((group, i) => {
                        const completedCount = group.tasks.filter(t => t.status === 'done').length;
                        const totalCount = group.tasks.length;
                        const pct = totalCount ? Math.round((completedCount / totalCount) * 100) : 0;
                        const barColor = pct===100?'#15803d':pct>=75?T.accent:pct>=50?'#b45309':'#b91c1c';
                        return (
                          <div key={group.id} style={{ marginBottom: i===taskGroups.length-1?0:'18px', backgroundColor:'#f9fafb', borderRadius:'8px', padding:'16px', border:`1px solid ${T.border}` }}>
                            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'10px' }}>
                              <span style={{ fontWeight:'600', color:T.textPrimary, fontSize:'13px' }}>{group.title}</span>
                              <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                                <span style={{ fontSize:'12px', color:T.textMuted }}>{completedCount}/{totalCount}</span>
                                <span style={{ padding:'3px 10px', backgroundColor:`${barColor}22`, color:barColor, borderRadius:'12px', fontSize:'11px', fontWeight:'700' }}>{pct}%</span>
                              </div>
                            </div>
                            <div style={{ height:'7px', backgroundColor:'#e5e7eb', borderRadius:'4px', overflow:'hidden' }}>
                              <div style={{ height:'100%', width:`${pct}%`, backgroundColor:barColor, borderRadius:'4px', transition:'width 0.5s cubic-bezier(0.4,0,0.2,1)' }} />
                            </div>
                            <div style={{ marginTop:'8px', display:'flex', gap:'14px', fontSize:'11px', color:T.textMuted }}>
                              <span><strong style={{ color:'#15803d' }}>{group.tasks.filter(t=>t.status==='done').length}</strong> Done</span>
                              <span><strong style={{ color:T.accent }}>{group.tasks.filter(t=>t.status==='in-progress').length}</strong> In Progress</span>
                              <span><strong style={{ color:'#b45309' }}>{group.tasks.filter(t=>t.status==='pending').length}</strong> Pending</span>
                              <span><strong style={{ color:'#b91c1c' }}>{group.tasks.filter(t=>t.status==='overdue').length}</strong> Overdue</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <AnalyticsComponent
                      blocks={blocks} setblocks={setblocks} get_chart={get_chart}
                      editingblocks={editingblocks} seteditingblocks={seteditingblocks}
                      delete_block={delete_KPI} handleEdit={handle_KPI_edit} updateBlockPosition={updateBlockPosition} />
                  </div>
                )}

                {/* ═══ DOCUMENTS ═══ */}
                {activeTab === 'documents' && (
                  <div style={{ animation:'slideUp 0.25s ease' }}>
                    {/* Search */}
                    <div style={{ marginBottom:'16px', position:'relative', maxWidth:'360px' }}>
                      <Search size={14} style={{ position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)', color:T.textMuted, pointerEvents:'none' }} />
                      <input type="text" placeholder="Search documents..." value={searchDocument}
                        onChange={(e) => setsearchDocument(e.target.value)}
                        className="dsr-input"
                        style={{ width:'100%', padding:'8px 12px 8px 36px', border:`1.5px solid ${T.borderMed}`, borderRadius:'8px', fontSize:'13px', color:T.textPrimary, backgroundColor:T.white, fontFamily:"'Inter',system-ui,sans-serif", outline:'none' }} />
                    </div>

                    {/* Upload area */}
                    <div
                      onDragEnter={handleDocumentDrag} onDragLeave={handleDocumentDrag}
                      onDragOver={handleDocumentDrag} onDrop={handleDocumentDrop}
                      style={{ border:`2px dashed ${dragActive?T.accent:T.borderMed}`, borderRadius:'12px', padding:'36px 24px', marginBottom:'20px', textAlign:'center', backgroundColor: dragActive?'#e0e7ff':'#f9fafb', transition:'all 0.25s', cursor:'pointer' }}
                      onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.backgroundColor='#eef2ff'; }}
                      onMouseLeave={(e) => { if (!dragActive) { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.backgroundColor='#f9fafb'; } }}>
                      <Upload size={36} color={T.textMuted} style={{ marginBottom:'10px', opacity:0.7 }} />
                      <p style={{ margin:'0 0 4px 0', fontSize:'14px', fontWeight:'600', color:T.textPrimary }}>Drag and drop files here</p>
                      <p style={{ margin:'0 0 14px 0', fontSize:'12px', color:T.textMuted }}>Support for PDF, Images, Spreadsheets, Videos, Audio and more</p>
                      <button onClick={() => fileInputRef.current?.click()}
                        className="dsr-btn-primary" style={btnPrimary}
                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#3730a3'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor=T.accent; }}>
                        Choose Files
                      </button>
                    </div>

                    {/* Documents list */}
                    <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
                      {filteredDocuments.map(doc => (
                        <div key={doc.id} className="dsr-card"
                          style={{ backgroundColor:T.white, border:`1px solid #e5e7eb`, borderRadius:'10px', padding:'14px 18px', display:'flex', justifyContent:'space-between', alignItems:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', transition:'all 0.15s' }}>
                          <div style={{ display:'flex', alignItems:'center', gap:'14px', flex:1 }}>
                            {getFileIcon(doc.type)}
                            <div style={{ flex:1 }}>
                              <h3 style={{ margin:'0 0 4px 0', fontSize:'14px', fontWeight:'600', color:T.textPrimary }}>{doc.name}</h3>
                              <div style={{ display:'flex', alignItems:'center', gap:'10px', fontSize:'12px', color:T.textMuted }}>
                                <span>{doc.uploadDate}</span>
                                <span style={{ padding:'2px 10px', backgroundColor:'#f3f4f6', color:T.textSecondary, borderRadius:'20px', fontSize:'11px', fontWeight:'500', border:`1px solid ${T.border}` }}>{doc.uploadedBy}</span>
                              </div>
                            </div>
                          </div>
                          <div style={{ display:'flex', gap:'6px' }}>
                            <button onClick={() => downloadDocument(doc.url)}
                              style={{ padding:'7px', border:`1.5px solid ${T.borderMed}`, borderRadius:'7px', cursor:'pointer', display:'flex', alignItems:'center', backgroundColor:T.white, color:T.textSecondary, transition:'all 0.15s' }}
                              onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.color=T.accent; }}
                              onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color=T.textSecondary; }}
                              title="Download">
                              <Download size={14} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>

                    {filteredDocuments.length === 0 && (
                      <div style={{ textAlign:'center', padding:'56px 24px', animation:'fadeIn 0.4s ease' }}>
                        <div style={{ width:'56px', height:'56px', backgroundColor:'#e5e7eb', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px auto' }}>
                          <File size={24} color={T.textMuted} />
                        </div>
                        <p style={{ margin:'0 0 6px 0', fontSize:'15px', fontWeight:'700', color:T.textPrimary }}>No documents found</p>
                        <p style={{ margin:0, fontSize:'13px', color:T.textMuted }}>Upload your first document to get started</p>
                      </div>
                    )}

                    <input ref={fileInputRef} type="file" multiple accept="*/*"
                      onChange={(e) => handleFiles(e.target.files)} style={{ display:'none' }} />
                  </div>
                )}

                {/* ═══ UPDATES ═══ */}
                {activeTab === 'updates' && (
                  <div style={{ display:'flex', flexDirection:'column', height:'calc(100vh - 220px)', animation:'slideUp 0.25s ease' }}>
                    {/* Search panel */}
                    {showSearchmessages && (
                      <div style={{ backgroundColor:T.white, border:`1px solid ${T.border}`, borderRadius:'10px', padding:'14px 18px', marginBottom:'14px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
                        <div style={{ position:'relative', marginBottom:'10px' }}>
                          <Search size={14} style={{ position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)', color:T.textMuted }} />
                          <input type="text" placeholder="Search messages..." value={searchQuerymessages}
                            onChange={(e) => setSearchQuerymessages(e.target.value)}
                            className="dsr-input"
                            style={{ width:'100%', padding:'8px 36px 8px 36px', border:`1.5px solid ${T.borderMed}`, borderRadius:'8px', fontSize:'13px', color:T.textPrimary, backgroundColor:T.white, fontFamily:"'Inter',system-ui,sans-serif", outline:'none' }} />
                          {searchQuerymessages && (
                            <button onClick={clearSearchmessages} style={{ position:'absolute', right:'10px', top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:T.textMuted, display:'flex' }}>
                              <X size={14} />
                            </button>
                          )}
                        </div>
                        <div style={{ display:'flex', gap:'6px', marginBottom:'8px' }}>
                          {['all','content','author'].map(type => (
                            <button key={type} onClick={() => setSearchTypemessages(type)}
                              style={{ padding:'5px 12px', border:'none', borderRadius:'7px', fontSize:'12px', fontWeight:'600', cursor:'pointer', fontFamily:"'Inter',system-ui,sans-serif",
                                background: searchTypemessages===type ? `linear-gradient(135deg,${T.accent},${T.tableHeaderAccent})` : '#e5e7eb',
                                color: searchTypemessages===type ? T.white : T.textMuted,
                                transition:'all 0.15s'
                              }}>
                              {type.charAt(0).toUpperCase()+type.slice(1)}
                            </button>
                          ))}
                        </div>
                        {searchQuerymessages && <div style={{ fontSize:'12px', color:T.textMuted }}>Found {filteredMessages.length} message{filteredMessages.length !== 1 ? 's' : ''}</div>}
                      </div>
                    )}

                    {/* Messages */}
                    <div ref={chatMessagesRef} onScroll={handleScroll}
                      style={{ flex:1, overflowY:'auto', backgroundColor:T.white, borderRadius:'10px', border:`1px solid #e5e7eb`, padding:'16px 20px', display:'flex', flexDirection:'column', gap:'12px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', marginBottom:'12px' }}>
                      {showLoadMore && (
                        <button onClick={loadMoreMessages}
                          style={{ position:'sticky', top:'8px', alignSelf:'center', padding:'8px 18px', background:`linear-gradient(135deg,${T.accent},${T.tableHeaderAccent})`, color:T.white, border:'none', borderRadius:'20px', cursor:'pointer', fontSize:'12px', fontWeight:'700', boxShadow:'0 2px 8px rgba(67,56,202,0.40)', zIndex:10, fontFamily:"'Inter',system-ui,sans-serif", transition:'all 0.15s' }}
                          onMouseEnter={(e) => { e.currentTarget.style.transform='translateY(-1px)'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.transform='translateY(0)'; }}>
                          Load older messages
                        </button>
                      )}

                      {filteredMessages.map(message => (
                        <div key={message.id} style={{ display:'flex', justifyContent: message.authorid === userid ? 'flex-end' : 'flex-start' }}>
                          <div style={{ position:'relative', paddingBottom:'28px', maxWidth:'68%', minWidth:'180px' }}>
                            <div style={{ borderRadius: message.authorid===userid ? '14px 14px 4px 14px' : '14px 14px 14px 4px', padding:'12px 16px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)',
                              ...(message.authorid===userid
                                ? { background:`linear-gradient(135deg,${T.accent},${T.tableHeaderAccent})`, color:T.white }
                                : { backgroundColor:T.white, color:T.textPrimary, border:`1px solid ${T.border}` })
                            }}>
                              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'6px', gap:'16px' }}>
                                <span style={{ fontWeight:'700', fontSize:'12px', opacity:0.9 }}>
                                  {searchQuerymessages && (searchTypemessages==='all'||searchTypemessages==='author')
                                    ? highlightTextmessages(message.author, searchQuerymessages) : message.author}
                                </span>
                                <span style={{ fontSize:'11px', opacity:0.65, whiteSpace:'nowrap' }}>{message.time}</span>
                              </div>
                              <div style={{ fontSize:'13px', lineHeight:'1.5', wordBreak:'break-word' }}>
                                {searchQuerymessages && (searchTypemessages==='all'||searchTypemessages==='content')
                                  ? highlightTextmessages(message.content, searchQuerymessages) : message.content}
                              </div>
                            </div>
                            {message.authorid === userid && (
                              <button onClick={() => deletemessage(message.id)}
                                style={{ position:'absolute', bottom:'4px', right:'4px', width:'24px', height:'24px', backgroundColor:'#fef2f2', color:'#b91c1c', display:'flex', alignItems:'center', justifyContent:'center', borderRadius:'6px', border:'1.5px solid #fca5a5', cursor:'pointer', transition:'all 0.15s' }}
                                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#fee2e2'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor='#fef2f2'; }}>
                                <Trash2 size={11} />
                              </button>
                            )}
                          </div>
                        </div>
                      ))}

                      {filteredMessages.length === 0 && (
                        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'200px', animation:'fadeIn 0.4s ease' }}>
                          <div style={{ width:'56px', height:'56px', backgroundColor:'#e5e7eb', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:'14px' }}>
                            <MessageCircle size={24} color={T.textMuted} />
                          </div>
                          <p style={{ fontSize:'15px', fontWeight:'700', color:T.textPrimary, margin:'0 0 4px 0' }}>
                            {searchQuerymessages ? 'No messages found' : 'No updates yet'}
                          </p>
                          <p style={{ fontSize:'12px', color:T.textMuted, margin:0 }}>
                            {searchQuerymessages ? 'Try a different search term' : 'Send the first update to get started'}
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Input area */}
                    <div style={{ position:'relative', backgroundColor:T.white, borderRadius:'10px', border:`1px solid #e5e7eb`, padding:'12px 14px', display:'flex', gap:'10px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
                      <input ref={chatInputRef} type="text" placeholder="Type a message... (@ to mention)"
                        value={chatInput} onChange={handleChatInputChange}
                        onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                        className="dsr-input"
                        style={{ flex:1, padding:'9px 14px', border:`1.5px solid ${T.borderMed}`, borderRadius:'8px', fontSize:'13px', backgroundColor:'#f9fafb', fontFamily:"'Inter',system-ui,sans-serif", color:T.textPrimary, outline:'none', transition:'border-color 0.15s' }} />
                      <button onClick={sendMessage}
                        className="dsr-btn-primary" style={{ ...btnPrimary, height:'auto', padding:'9px 18px' }}
                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#3730a3'; e.currentTarget.style.transform='translateY(-1px)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor=T.accent; e.currentTarget.style.transform='translateY(0)'; }}>
                        <Send size={13} /> Send
                      </button>
                      {showUserList && (
                        <div style={{ position:'absolute', bottom:'100%', left:0, right:0, backgroundColor:T.white, borderRadius:'10px', boxShadow:'0 8px 24px rgba(0,0,0,0.12)', border:`1px solid ${T.border}`, maxHeight:'180px', overflowY:'auto', zIndex:1000, marginBottom:'6px' }}>
                          {allusersnames.filter(user => user.name.toLowerCase().includes(currentMentionSearch.toLowerCase())).map(user => (
                            <div key={user.id}
                              onClick={() => selectUser(user.id, user.name)}
                              style={{ padding:'9px 14px', cursor:'pointer', fontSize:'13px', color:T.textSecondary, borderBottom:`1px solid #f3f4f6`, fontWeight:'500' }}
                              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor='#eef2ff'; e.currentTarget.style.color='#4338ca'; }}
                              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor='transparent'; e.currentTarget.style.color=T.textSecondary; }}>
                              {user.name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* ═══ KNOWLEDGE BASE ═══ */}
                {activeTab === 'knowledge-base' && (
                  <div style={{ animation:'slideUp 0.25s ease' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:'12px', marginBottom:'16px' }}>
                      <div style={{ position:'relative', flex:1, maxWidth:'360px' }}>
                        <Search size={14} style={{ position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)', color:T.textMuted, pointerEvents:'none' }} />
                        <input type="text" placeholder="Search knowledge base..." value={searchknowledgebase}
                          onChange={(e) => setsearchknowledgebase(e.target.value)}
                          className="dsr-input"
                          style={{ width:'100%', padding:'8px 12px 8px 36px', border:`1.5px solid ${T.borderMed}`, borderRadius:'8px', fontSize:'13px', color:T.textPrimary, backgroundColor:T.white, fontFamily:"'Inter',system-ui,sans-serif", outline:'none' }} />
                      </div>
                      <button onClick={() => setShowFilters(!showFilters)}
                        style={{ display:'flex', alignItems:'center', gap:'6px', padding:'8px 14px', border:`1.5px solid ${showFilters?T.accent:T.borderMed}`, borderRadius:'8px', fontSize:'12px', fontWeight:'600', cursor:'pointer', fontFamily:"'Inter',system-ui,sans-serif", backgroundColor: showFilters?'#e0e7ff':T.white, color: showFilters?T.tableHeaderAccent:'#374151', transition:'all 0.15s' }}>
                        <Filter size={13} /> Filters
                        <ChevronDown size={13} style={{ transform: showFilters?'rotate(180deg)':'rotate(0deg)', transition:'transform 0.25s' }} />
                      </button>
                    </div>

                    {showFilters && (
                      <div style={{ backgroundColor:'#f9fafb', border:`1.5px solid ${T.border}`, borderRadius:'10px', padding:'16px', marginBottom:'20px' }}>
                        <h3 style={{ margin:'0 0 12px 0', fontSize:'12px', fontWeight:'700', color:T.textSecondary, textTransform:'uppercase', letterSpacing:'0.06em' }}>Filter by Tags</h3>
                        <div style={{ display:'flex', flexWrap:'wrap', gap:'6px' }}>
                          {allTags.map(tag => (
                            <button key={tag} onClick={() => toggleTag(tag)}
                              style={{ padding:'5px 12px', border:`1.5px solid ${selectedTags.includes(tag)?T.accent:T.borderMed}`, borderRadius:'20px', fontSize:'12px', fontWeight:'500', cursor:'pointer', transition:'all 0.15s', fontFamily:"'Inter',system-ui,sans-serif", backgroundColor: selectedTags.includes(tag)?T.accent:T.white, color: selectedTags.includes(tag)?T.white:'#374151' }}>
                              {tag}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))', gap:'20px' }}>
                      {filteredknowledgebase.map(item => (
                        <div key={item.id} className="dsr-card"
                          style={{ backgroundColor:T.white, borderRadius:'10px', padding:'20px', border:`1px solid #e5e7eb`, boxShadow:'0 1px 4px rgba(0,0,0,0.06)', transition:'all 0.15s', cursor:'pointer', position:'relative', overflow:'hidden' }}>
                          <div style={{ display:'flex', alignItems:'center', gap:'6px', marginBottom:'12px', fontSize:'11px', fontWeight:'700', textTransform:'uppercase', letterSpacing:'0.04em', color:getTypeColor(item.type) }}>
                            {getFileIcon(item.type)} {item.type}
                          </div>
                          <h3 style={{ fontSize:'15px', fontWeight:'700', color:T.textPrimary, marginBottom:'6px', margin:'0 0 6px 0', lineHeight:'1.3' }}>{item.title}</h3>
                          <p style={{ fontSize:'12px', color:T.textMuted, lineHeight:'1.5', margin:'0 0 12px 0' }}>{item.description}</p>
                          <div style={{ display:'flex', alignItems:'center', fontSize:'11px', color:T.textMuted, marginBottom:'12px', gap:'5px' }}>
                            <Calendar size={11} /> {item.dateAdded}
                          </div>
                          <div style={{ display:'flex', flexWrap:'wrap', gap:'4px', marginBottom:'14px' }}>
                            {item.tags.slice(0,3).map(tag => (
                              <span key={tag} style={{ padding:'2px 8px', backgroundColor:'#f3f4f6', color:T.textSecondary, borderRadius:'6px', fontSize:'11px', fontWeight:'500' }}>{tag}</span>
                            ))}
                          </div>
                          <div style={{ display:'flex', gap:'6px', paddingTop:'12px', borderTop:`1px solid #f1f5f9` }}>
                            <button onClick={(e) => { e.stopPropagation(); window.open('https://api.successguardian.in/media/'+item.url,'_blank'); }}
                              style={{ padding:'6px 10px', border:`1.5px solid ${T.borderMed}`, borderRadius:'7px', fontSize:'12px', fontWeight:'600', cursor:'pointer', backgroundColor:T.white, color:T.textSecondary, display:'flex', alignItems:'center', gap:'4px', transition:'all 0.15s', fontFamily:"'Inter',system-ui,sans-serif" }}
                              onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.color=T.accent; }}
                              onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color=T.textSecondary; }}>
                              <Eye size={12} /> View
                            </button>
                            {item.type !== 'link' ? (
                              <button onClick={(e) => { e.stopPropagation(); downloadDocument(item.url); }}
                                style={{ padding:'6px 10px', border:`1.5px solid ${T.borderMed}`, borderRadius:'7px', fontSize:'12px', fontWeight:'600', cursor:'pointer', backgroundColor:T.white, color:T.textSecondary, display:'flex', alignItems:'center', gap:'4px', transition:'all 0.15s', fontFamily:"'Inter',system-ui,sans-serif" }}
                                onMouseEnter={(e) => { e.currentTarget.style.borderColor='#15803d'; e.currentTarget.style.color='#15803d'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color=T.textSecondary; }}>
                                <Download size={12} /> Download
                              </button>
                            ) : (
                              <button onClick={(e) => { e.stopPropagation(); window.open(item.url,'_blank'); }}
                                style={{ padding:'6px 10px', border:`1.5px solid ${T.borderMed}`, borderRadius:'7px', fontSize:'12px', fontWeight:'600', cursor:'pointer', backgroundColor:T.white, color:T.textSecondary, display:'flex', alignItems:'center', gap:'4px', transition:'all 0.15s', fontFamily:"'Inter',system-ui,sans-serif" }}
                                onMouseEnter={(e) => { e.currentTarget.style.borderColor=T.accent; e.currentTarget.style.color=T.accent; }}
                                onMouseLeave={(e) => { e.currentTarget.style.borderColor=T.borderMed; e.currentTarget.style.color=T.textSecondary; }}>
                                <ExternalLink size={12} /> Open Link
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>

                    {filteredknowledgebase.length === 0 && (
                      <div style={{ textAlign:'center', padding:'56px 24px', animation:'fadeIn 0.4s ease' }}>
                        <div style={{ width:'56px', height:'56px', backgroundColor:'#e5e7eb', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px auto' }}>
                          <BringToFront size={24} color={T.textMuted} />
                        </div>
                        <p style={{ margin:'0 0 6px 0', fontSize:'15px', fontWeight:'700', color:T.textPrimary }}>No resources found</p>
                        <p style={{ margin:0, fontSize:'13px', color:T.textMuted }}>Upload your first resource to get started</p>
                      </div>
                    )}
                  </div>
                )}

              </div>
            </div>
          </div>

          {/* ── MODAL ── */}
          <ViewTaskModal
            viewtask={viewtask}
            setviewtask={setviewtask}
            task_name={task_name}
            task_user={task_user}                  
            task_status={task_status}
            task_user_list={allusersnames}
            task_priority={task_priority}
            task_created_date={task_created_date}
            task_due_date={task_due_date}
            task_note={task_note}
            alladdtionalfieldsvalues={alladdtionalfieldsvalues}
            setloading={setloading}
          />

        </div>
       </SkeletonWrapper>
    </>
  );
};

export default DigitalSuccessRoomUniv;